"use client"
import { CryptoModal } from "../Pop-up/newPopUP";
import { Carousel } from "@material-tailwind/react";

export default function Marquee() {
  return (
    <div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
      <div
        aria-hidden="true"
        className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
      >
        <div
          style={{
            clipPath:
              'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
          }}
          className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#292727] to-[#F4F5F0] opacity-30"
        />
      </div>
      <div
        aria-hidden="true"
        className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
      >
        <div
          style={{
            clipPath:
              'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
          }}
          className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#292727] to-[#F4F5F0] opacity-30"
        />
      </div>
      <Carousel
        autoplay={true}
        loop={true}
        autoplayDelay={6000}
        navigation={false}
        className="hidden overflow-y-hidden lg:flex"
      >
        <div className="flex ml-[30%] 2xl:ml-[35%] flex-wrap items-center gap-x-4 gap-y-2">
          <p className="block text-sm leading-6 text-gray-900">
            <strong className="hidden md:inline font-semibold">DESCUENTO</strong>
            <svg viewBox="0 0 2 2" aria-hidden="true" className="hidden lg:inline mx-2 h-0.5 w-0.5 fill-current">
              <circle r={1} cx={1} cy={1} />
            </svg>
            15% off en todos los accesorios, cupón: #minca15
          </p>
          <a href="/productos/Accesorios_Minca" className="flex-none rounded-full bg-black px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-[#42454A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900">Ver accesorios</a>
        </div>
        <div className="flex ml-[30%] 2xl:ml-[35%] flex-wrap items-center gap-x-4 gap-y-2">
          <p className="block text-sm leading-6 text-gray-900">
            <strong className="hidden md:inline font-semibold">EL MEJOR DESCUENTO DEL AÑO</strong>
            <svg viewBox="0 0 2 2" aria-hidden="true" className="hidden lg:inline mx-2 h-0.5 w-0.5 fill-current">
              <circle r={1} cx={1} cy={1} />
            </svg>
            Preventa Minca 800W
          </p>
          <a href="/especificaciones/Especificaciones_Scooter_Electrico_Minca_800W" className="flex-none rounded-full bg-black px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-[#42454A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900">Comprar ahora</a>
        </div>
        {/* <div className="flex ml-[30%] 2xl:ml-[35%] flex-wrap items-center gap-x-4 gap-y-2">
          <p className="block text-sm leading-6 text-gray-900">
            <strong className="hidden md:inline font-bold">#SORTEOMINCA1600W</strong>
            <svg viewBox="0 0 2 2" aria-hidden="true" className="hidden lg:inline mx-2 h-0.5 w-0.5 fill-current">
              <circle r={1} cx={1} cy={1} />
            </svg>
            ¡Participa y gana una Minca GRATIS!
          </p>
          <CryptoModal/>
        </div> */}
      </Carousel>
      <div className="flex flex-1 justify-end">
        <button type="button" className="-m-3 p-3 focus-visible:outline-offset-[-4px]">
          <span className="sr-only">Dismiss</span>
        </button>
      </div>
    </div>
  )
}